import { Component } from 'react'
import { connect } from 'react-redux'
import { H4 } from '../../cdl-react-components/components'
import Link from '../Link'
import { setConfiguration } from '../../../store/actions'
import { graphqlFetch } from '../../cdl-react-components/utilities'

class ContentGroups extends Component {
    render() {
        let { contentGroups } = this.props
        contentGroups = contentGroups && contentGroups.filter(x => x.id !== 1)

        return contentGroups ? (
            <div className="content-groups">
                { contentGroups.map(group => (
                    <Link 
                        href={'/contentGroup/' + group.id}
                        key={'content-group--' + group.id}
                        title={group.name}
                        className="content-group">
                        <H4>{group.name}</H4>
                    </Link>
                ))}
            </div>) : null
    }

    componentDidMount() {
        if (!this.props.contentGroups) {
            graphqlFetch('wcms3', `
                query {
                    contentGroups (
                        order: { priority: DESC }
                        where: { activeGroup: { eq: true } }
                    ) {
                        id
                        name
                        priority
                        active_group: activeGroup
                    }
                }`)
                .then(res => {                    
                    const groups = res.data.contentGroups
                    this.props.setContentGroups(groups)
                })
        }
    }
}

const mapStateToProps = ({ data }) => ({ contentGroups: data.configuration.contentGroups })
const mapDispatchToProps = (dispatch) => ({ setContentGroups: contentGroups => dispatch(setConfiguration({ contentGroups }))})

export default connect(mapStateToProps, mapDispatchToProps)(ContentGroups)